import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=86c4f746&scoped=true&"
import script from "./ConfirmDialog.vue.js?vue&type=script&lang=js&"
export * from "./ConfirmDialog.vue.js?vue&type=script&lang=js&"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=86c4f746&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c4f746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle})
